/*
 * File: SearchResults.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the search results in the post charges dx search
 */
import React, { useState } from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import UIProgress from "components/ui/UIProgress";
import UISnackbar from "components/ui/UISnackbar";
import PropTypes from "prop-types";
import UINotFound from "components/ui/UINotFound";
import { observer } from "mobx-react";

const SearchResults = ({ data, handleResultClick, selectedDiagnosesStore }) => {
  const { diagnosesSearchResult, loading, searched } = data;
  const [dxDuplicated, setDxDuplicated] = useState(false);

  const handleDiagnosisClick = result => {
    const isSelectedDxDuplicate = selectedDiagnosesStore.isDuplicateDiagnosis(
      result.umlsId
    );
    setDxDuplicated(isSelectedDxDuplicate);
    if (!isSelectedDxDuplicate) {
      handleResultClick(result);
    }
  };

  const snackbarClosed = () => {
    setDxDuplicated(false);
  };

  return (
    <React.Fragment>
      {loading && <UIProgress />}
      {!loading &&
        searched &&
        diagnosesSearchResult &&
        diagnosesSearchResult.length === 0 && (
          <UINotFound message="There are no diagnoses matching your search.  Search again or exit the search" />
        )}

      {searched && diagnosesSearchResult && (
        <List className="navList">
          {diagnosesSearchResult.map((i, index) => {
            return (
              <ListItem key={index} onClick={() => handleDiagnosisClick(i)}>
                <ListItemText primary={i.code} secondary={i.diagnosis} />
              </ListItem>
            );
          })}
        </List>
      )}

      {searched && diagnosesSearchResult && dxDuplicated && (
        <UISnackbar
          message="Cannot Add Duplicate Diagnoses"
          open={dxDuplicated}
          variant="error"
          onClose={snackbarClosed}
        />
      )}
    </React.Fragment>
  );
};

SearchResults.propTypes = {
  data: PropTypes.object.isRequired,
  handleResultClick: PropTypes.func.isRequired,
  selectedDiagnosesStore: PropTypes.object.isRequired
};

export default observer(SearchResults);
